import { specials } from '@/mocks/specials';

export function getSpecialsList() {
  return specials;
}